import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { BASE, PRICES } from '../captivision.config';
import { CV_APPS, CVAppStoreBadge, CVFavicon, CVTopbar, CVFooter, useCaptiVisionTheme } from '../shell.component';
import { useDocumentTitle } from '../document.component';
import { fill, fillText, formatPrice, useCVLanguage } from '../i18n/language.component';

import '../captivision.styles.scss';

// What CaptiVision costs, in the reader's language: the plans, the note that
// the App Store charges local prices, what is worth knowing before
// subscribing, and the two apps to download. The copy is `pricing` in the
// strings files. The route is only there while SHOW_PRICING is on.

const CaptiVisionPricing = () => {
    const [theme, toggleTheme] = useCaptiVisionTheme();
    const { code, t } = useCVLanguage();
    const pricing = t.pricing;
    const prices = { monthly: formatPrice(code, PRICES.monthly), yearly: formatPrice(code, PRICES.yearly) };

    useDocumentTitle(t.nav.pricing)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="captivision cv-pricing-page">
            <CVFavicon />
            <CVTopbar theme={theme} onToggleTheme={toggleTheme} current="Pricing" />

            <main>
                <header className="cv-page cv-pricing-head">
                    <span className="cv-eyebrow"> {pricing.kicker} </span>
                    <h1> {pricing.title} </h1>
                    <p className="cv-lede"> {pricing.lede} </p>
                </header>

                {/* The plans, and where no one misses it, that prices differ by region */}
                <section className="cv-page">
                    <table className="cv-prices">
                        <tbody>
                            {pricing.tiers.map(tier => (
                                <tr key={tier.name}>
                                    <th>
                                        {tier.name}
                                        <small> {tier.note} </small>
                                    </th>
                                    <td className="cv-price">
                                        {fillText(tier.price, prices)} {tier.per ? <span> {tier.per} </span> : null}
                                    </td>
                                    <td> {tier.blurb} </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <p className="cv-tip cv-price-region"><b>{pricing.regionLabel}</b>{pricing.region}</p>
                    <p className="cv-fine">
                        {fill(pricing.fine, { terms: <Link to={`${BASE}/terms`}>{pricing.terms}</Link> })}
                    </p>
                </section>

                <section className="cv-page cv-section">
                    <div className="cv-section-head">
                        <h2> {pricing.good.title} </h2>
                    </div>
                    <div className="cv-uses cv-uses-2">
                        {pricing.good.items.map(item => (
                            <div className="cv-use" key={item.title}>
                                <h3> {item.title} </h3>
                                <p> {item.body} </p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* the place to act: both apps, with the App Store badges */}
                <section className="cv-page cv-closing">
                    <h2> {pricing.download} </h2>
                    <div className="cv-pricing-apps">
                        {CV_APPS.map(app => (
                            <div key={app.key}>
                                <img className="cv-app-icon" src={app.icon} alt="" loading="lazy"/>
                                <h3> {app.name} </h3>
                                <CVAppStoreBadge app={app}/>
                            </div>
                        ))}
                    </div>
                </section>
            </main>

            <CVFooter />
        </div>
    )
}

export default CaptiVisionPricing;
